// Pages
import RouterView from '@/components/pages/RouterView/Router'

import RayproAdmin from '@/components/pages/RayproAdmin/RayproAdmin.vue'
import EditRayproAdmin from '@/components/pages/RayproAdmin/RayproAdminEdit.vue'

export default {
  path: '/raypro_admins',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      redirect: '/users'
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: RayproAdmin,
          props: true,
          name: 'view-admin'
        },
        {
          path: 'edit',
          component: EditRayproAdmin,
          name: 'edit-admin',
          props: true,
          meta: {breadcrumb: 'Edit'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/raypro_admin.js